<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/subadmin-mgt">Sub Admin Management </a>
            </li>
            <li class="breadcrumb-item">View</li>
        </ol>
        <div class="order-view mb20 max-WT-600 mrgn-0-auto">
            <div class="main-block-innner">
                <div class="add-store-block input-style mw-100">

                    <div class="form-user">
                        <form>

                            <div class="text-center mt-4 mb-5">
                                <div class="flex-block align-center">
                                    <div class="profile_block" style="position: relative">
                                        <img [src]="subAdminList?.profilePic ||  'assets/img/profile-img.jpg'"
                                            class="imagePicture" alt="banner image" (error)="onImageError($event)" />
                                    </div>

                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-6 col-form-label">
                                    <h6>First Name : </h6>
                                </label>
                                <div class="col-sm-6">
                                    <label class=" col-form-label"> {{subAdminList?.firstName}} </label>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-6 col-form-label">
                                    <h6>Last Name : </h6>
                                </label>
                                <div class="col-sm-6">
                                    <label class=" col-form-label"> {{subAdminList?.lastName}}</label>
                                </div>
                            </div>


                            <div class="form-group row">
                                <label class="col-sm-6 col-form-label">
                                    <h6>Email : </h6>
                                </label>
                                <div class="col-sm-6">
                                    <label class=" col-form-label">{{subAdminList?.email}}</label>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="inputPassword" class="col-sm-6 col-form-label">
                                    <h6>Phone Number : </h6>
                                </label>
                                <div class="col-sm-6">
                                    <label class="col-form-label">{{subAdminList?.mergeContact}}</label>
                                </div>
                            </div>
                            <div class="row ">
                                <label class="col-md-12">
                                    <h6> Permissions :</h6>
                                </label>
                            </div>
                            <div class="form-group row">
                                @for (item of myPermission; track item; let i = $index) {
                                <div class="col-sm-6 mt-3">
                                    {{item | titlecase }}
                                </div>
                                }
                            </div>
                        </form>

                    </div>
                    <div class="d-flex justify-content-center mt-5 mb-5">
                        <button class="btn btn-theme" routerLink='/subadmin-mgt'>Back</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Table Responsive End -->

</main>